import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  cardContent: {
    composes: ['card-content'],
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
  },
});
const CardContent = ({ children }) => (
  <div className={useStyle().cardContent}>
    {children}
  </div>
);

export default CardContent;
